
export default {
  props: {
    placeholder: {
      type: String,
      default: "Search",
    },
    compact: {
      type: Boolean,
      default: false,
    },
    initialValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShow: !!this.initialValue,
      typed: this.initialValue || "",
    };
  },
  watch: {
    initialValue(val) {
      this.typed = val;
      this.isShow = !!val;
    },
    typed: function () {
      this.$emit("add", "name", this.typed);
    },
  },
  mounted() {
    this.$root.$on("search:set-typed", (typed) => {
      this.typed = typed;
      this.isShow = true;
    });
  },
  methods: {
    searchHover(state) {
      if (state == "over") {
        this.isShow = true;
      } else {
        !this.typed ? (this.isShow = false) : "";
      }
    },

    closeSearch() {
      this.typed = "";
      this.isShow = false;
    },

    onClickOutside() {
      if (this.typed) {
        return;
      }
      this.isShow = false;
    },
  },
};
